export const languages = {
    ru: 'Русский',
    en: 'English',
};
